import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import Floor from "../../floorBuilder/Floor";
import useZibi from "../../../zibi/UseZibi";
import {colors} from "../../../maps/colors";

const WrapperStyled = styled.div`
    width: 100%;

    h3 {
        text-align: center;
        margin: 0;
    }
`;

const FloorWrapperStyled = styled.div`
    width: 100%;
    position: relative;
`;

const DrawBoxStyled = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #FFFFFF50;
    z-index: 1;
`;


const RoiFloorItem = ({title, edge, drawBoundingBox, onAddDot, onMoveDot, box, wrapperWidth, wrapperHeight}) => {
    const wrapperRef = useRef(null);

    const {floor} = edge;

    const [sensorStatuses] = useZibi('sensorStatuses');
    const [height, s_height] = useState(0);
    const [width, s_width] = useState(0);

    const [x, s_x] = useState(0);
    const [y, s_y] = useState(0);

    const [y_percent, s_y_percent] = useState(0);
    const [x_percent, s_x_percent] = useState(0);

    useEffect(() => {
        if (wrapperRef.current && wrapperRef.current.offsetWidth) {
            s_height(wrapperRef.current.offsetHeight);
            s_width(wrapperRef.current.offsetWidth);
        }
    }, [wrapperRef?.current]);

    const mouseMove = e => {
        if (drawBoundingBox) {
            const pos = e.currentTarget.getBoundingClientRect();
            let current_x = parseInt(e.clientX - pos.left);
            let current_y = parseInt(e.clientY - pos.top);
            let current_x_percent = Number((x / wrapperWidth * 100).toFixed(2));
            let current_y_percent = Number((y / wrapperHeight * 100).toFixed(2));

            s_x(current_x);
            s_y(current_y);
            s_x_percent(current_x_percent);
            s_y_percent(current_y_percent);

            onMoveDot({
                x: current_x,
                y: current_y,
                x_percent: current_x_percent,
                y_percent: current_y_percent
            });
        }
    };

    const mouseClick = () => {
        if (drawBoundingBox) {
            onAddDot({
                x,
                y,
                x_percent,
                y_percent
            });
        }
    };

    return (
        <WrapperStyled
            ref={wrapperRef}
            style={{height: wrapperHeight}}
        >
            <h3>{title}</h3>
            <FloorWrapperStyled
                style={{height: wrapperHeight}}
            >
                {drawBoundingBox && (
                    <DrawBoxStyled
                        style={{zIndex: 2}}
                        onMouseMove={mouseMove}
                        onClick={mouseClick}
                    />
                )}

                <DrawBoxStyled>
                    <svg
                        height="100%" width="100%"
                        style={{position: 'absolute', top: 0, left: 0}}>
                        <polygon points={
                            box.map(dot => {
                                return (
                                    `${dot.x_percent * wrapperWidth / 100},${dot.y_percent * wrapperHeight / 100}`
                                );
                            }).join(',')
                        } style={{
                            fill: colors.LIGHT_GRAY_HALF_TRANS,
                            stroke: 'white',
                            strokeWidth: 2
                        }}/>
                    </svg>
                </DrawBoxStyled>
                <Floor
                    onMouseMove={() => {
                    }}
                    onMouseDown={() => {
                    }}
                    onMouseUp={() => {
                    }}
                    floor_width={floor.width}
                    floor_height={floor.height}
                    show_steps={true}
                    floor_stage_steps={floor?.floorEdgeSteps || []}
                    show_fields={true}
                    floor_selected_item={null}
                    sensorStatuses={sensorStatuses}
                    check_in_draw_mode={false}
                    s_floor_selected_item={() => {
                    }}
                    setSelectedFactors={() => {
                    }}
                    floor_stage_fields={floor?.floorEdgeFields || []}
                    show_camera={false}
                    floor_stage_cameras={floor?.floorEdgeCameras || []}
                    check_in_rect={[]}
                    check_in_display={false}
                    resizeAreaSelected={null}
                    s_resizeAreaSelected={() => {
                    }}
                    check_out_rect={[]}
                    check_out_display={false}
                    selected_factors={{}}
                    show_knns={false}
                    knns={[]}
                    resizeAreaHandle={() => {
                    }}
                    selectedImage={{}}
                />
            </FloorWrapperStyled>
        </WrapperStyled>
    );
};

export default RoiFloorItem;